import {
  Text,
  // @ts-ignore
} from 'atomize';

export const Description = () => {
  return (
    <Text p={{ t: "1rem" }}>
      Provenance is everything.
      <br />
      <br />
      Below, you will be presented with an option
      <br />
      to vote at the price of 0.1 ETH or 0.01 ETH.
      <br />
      <br />
      Whichever vote wins, I will donate the total
      <br />
      amount of ETH for that category to <a href='https://www.blackgirlscode.com/' target='_blank'>Black Girls Code</a>
      <br />
      and keep the amount of ETH in the other category.
      <br />
      <br />
      When the votes are tallied... will you have
      <br />
      donated "MORE" or "LESS"?
      <br />
    </Text>
  )
}